<!-- Author ミィン -->
<!-- 適用事業所が廃止、休止等により適用事業所 -->

<template>
  <div v-show="show">
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t('general.add')}}
        </el-button>
      </el-form-item>
    </el-form>

    <!-- Table -->
    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px"
      :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('companyInfo.name1')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name1 + scope.row.name2 +scope.row.name3 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('suspension_notice.office_ref_num')" align="center">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-button type="text" @click="handleDetails(scope.$index, scope.row)">{{ scope.row.office_ref_num }}
            </el-button>
          </div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('companyInfo.company_code')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.company_code}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('suspension_notice.zensou_date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.zensou_date}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('suspension_notice.zensou_causes')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.zensou_causes }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t('general.edit')}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t('general.delete')}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t('general.print')}}</el-button>
          <!-- <el-button size="mini" type="success" icon="el-icon-view" @click="preview(scope.$index, scope.row)" plain>
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- New -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="40%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm" size="mini"
        :label-position="labelPosition">
        <el-collapse accordion>
          <el-collapse-item :title="$t('general.general_info')" name="1" class="title" style="margin-left:10px">
            <el-row>
              <el-col :span="20">
                <div>
                  <el-form-item :label="$t('companyInfo.name')+':'" prop="name1" style="margin-left:50px">
                    <el-select v-model="ruleForm.name1" clearable style="margin-left:10px;width: 185px" size="mini"
                      :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.name1">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.office_ref_num')+':'" prop="office_ref_num"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.office_ref_num" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="1234"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.report_date')+':'" prop="report_date"
                    style="margin-left:50px">
                    <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.report_date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                      placeholder="2020-03-11"></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.resume_date')+':'" prop="resume_date"
                    style="margin-left:50px">
                    <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.resume_date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                      placeholder="2020-03-11"></el-date-picker>
                    <el-button class="el-icon-warning" style="color: red" type="text" @click="open1">
                      {{$t('general.warning')}}</el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('suspension_notice.information_losses')" name="2" style="margin-left:10px">
            <el-row>
              <el-col :span="15">
                <div>
                  <el-form-item :label="$t('suspension_notice.zensou_name')+':'" prop="zensou_name"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.zensou_name" size="mini"
                      style="margin-left:10px;width: 185px" placeholder></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_date')+':'" prop="zensou_date"
                    style="margin-left:50px">
                    <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.zensou_date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                      placeholder="2020-03-10"></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_postcode')+':'" prop="zensou_postcode"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.zensou_postcode" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="177-0055"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_address')+':'" prop="zensou_address"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.zensou_address" size="mini"
                      style="margin-left:10px;width: 185px" placeholder></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_tele')+':'" prop="zensou_tele"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.zensou_tele" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="＜例＞010-2222-3333"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.reason')+':'" prop="reason" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.reason" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="......."></el-input>
                    <el-button class="el-icon-info" type="text" @click="open2">{{$t('general.hint')}}</el-button>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_causes')+':'" prop="zensou_causes"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.zensou_causes" clearable style="margin-left:10px;width: 185px"
                      size="mini" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in zensou_causes" :key="item.zensou_causesId" :label="item.name"
                        :value="item.name"></el-option>
                    </el-select>
                    <el-button class="el-icon-warning" style="color: red" type="text" @click="reasonMesg">
                      {{$t('general.warning')}}</el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}</el-button>
      </span>
    </el-dialog>

    <!-- Edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="40%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm" size="mini"
        :label-position="labelPosition">
        <el-collapse accordion>
          <el-collapse-item :title="$t('general.general_info')" name="1" class="title" style="margin-left:10px">
            <el-row>
              <el-col :span="20">
                <div>
                  <el-form-item :label="$t('companyInfo.name')+':'" prop="name1" style="margin-left:50px">
                    <el-select v-model="ruleForm.name1" clearable style="margin-left:10px;width: 185px" size="mini"
                      :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.name1">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.office_ref_num')+':'" prop="office_ref_num"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.office_ref_num" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="1234"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.report_date')+':'" prop="report_date"
                    style="margin-left:50px">
                    <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.report_date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                      placeholder="2020-03-11"></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.resume_date')+':'" prop="resume_date"
                    style="margin-left:50px">
                    <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.resume_date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                      placeholder="2020-03-11"></el-date-picker>
                    <el-button class="el-icon-warning" style="color: red" type="text" @click="open1">
                      {{$t('general.warning')}}</el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('suspension_notice.information_losses')" name="2" style="margin-left:10px">
            <el-row>
              <el-col :span="15">
                <div>
                  <el-form-item :label="$t('suspension_notice.zensou_name')+':'" prop="zensou_name"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.zensou_name" size="mini"
                      style="margin-left:10px;width: 185px" placeholder></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_date')+':'" prop="zensou_date"
                    style="margin-left:50px">
                    <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.zensou_date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                      placeholder="2020-03-10"></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_postcode')+':'" prop="zensou_postcode"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.zensou_postcode" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="177-0055"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_address')+':'" prop="zensou_address"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.zensou_address" size="mini"
                      style="margin-left:10px;width: 185px" placeholder></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_tele')+':'" prop="zensou_tele"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.zensou_tele" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="＜例＞010-2222-3333"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.reason')+':'" prop="reason" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.reason" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="......."></el-input>
                    <el-button class="el-icon-info" type="text" @click="open2">{{$t('general.hint')}}</el-button>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_causes')+':'" prop="zensou_causes"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.zensou_causes" clearable style="margin-left:10px;width: 185px"
                      size="mini" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in zensou_causes" :key="item.zensou_causesId" :label="item.name"
                        :value="item.name"></el-option>
                    </el-select>
                    <el-button class="el-icon-warning" style="color: red" type="text" @click="reasonMesg">
                      {{$t('general.warning')}}</el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}</el-button>
      </span>
    </el-dialog>

    <!-- Detail -->
    <el-dialog :title="$t('general.detail')" :append-to-body="true" :visible.sync="dialogDetails" width="40%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm" size="mini"
        :label-position="labelPosition">
        <el-collapse accordion>
          <el-collapse-item :title="$t('general.general_info')" name="1" class="title" style="margin-left:10px">
            <el-row>
              <el-col :span="20">
                <div>
                  <el-form-item :label="$t('companyInfo.name')+':'" prop="name1" style="margin-left:50px">
                    <el-select v-model="ruleForm.name1" clearable style="margin-left:10px;width: 185px" size="mini"
                      :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.name1">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.office_ref_num')+':'" prop="office_ref_num"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.office_ref_num" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="1234" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.report_date')+':'" prop="report_date"
                    style="margin-left:50px">
                    <el-date-picker prefix-icon="el-icon-info" v-model="ruleForm.report_date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                      placeholder="2020-03-11" readonly="readonly"></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.resume_date')+':'" prop="resume_date"
                    style="margin-left:50px">
                    <el-date-picker prefix-icon="el-icon-info" v-model="ruleForm.resume_date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                      placeholder="2020-03-11" readonly="readonly"></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('suspension_notice.information_losses')" name="2" style="margin-left:10px">
            <el-row>
              <el-col :span="15">
                <div>
                  <el-form-item :label="$t('suspension_notice.zensou_date')+':'" prop="zensou_date"
                    style="margin-left:50px">
                    <el-date-picker prefix-icon="el-icon-info" v-model="ruleForm.zensou_date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                      placeholder="2020-03-10" readonly="readonly"></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_postcode')+':'" prop="zensou_postcode"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.zensou_postcode" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="177-0055" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_address')+':'" prop="zensou_address"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.zensou_address" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_name')+':'" prop="zensou_name"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.zensou_name" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_tele')+':'" prop="zensou_tele"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.zensou_tele" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.reason')+':'" prop="reason" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.reason" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                    <el-button class="el-icon-info" type="text" @click="open2">{{$t('general.hint')}}</el-button>
                  </el-form-item>

                  <el-form-item :label="$t('suspension_notice.zensou_causes')+':'" prop="zensou_causes"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.zensou_causes" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="cancel()" type="primary" size="medium">閉じる</el-button>
      </span>
    </el-dialog>

    <br />

    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        zensou_causes: [{
            zensou_causesID: 1,
            name: "解散1"
          },
          {
            zensou_causesID: 2,
            name: "休業2"
          },
          {
            zensou_causesID: 3,
            name: "合併3"
          },
          {
            zensou_causesID: 4,
            name: "任適脱退認可4"
          },
          {
            zensou_causesID: 5,
            name: "認定喪失5"
          },
          {
            zensou_causesID: 6,
            name: "その他7"
          },
          {
            zensou_causesID: 7,
            name: "一括適用8"
          }
        ],
        ruleForm: {
          id: "",
          office_ref_num: "",
          zensou_date: "",
          zensou_causes: "",
          resume_date: "",
          zensou_postcode: "",
          zensou_address: "",
          zensou_name: "",
          zensou_tele: "",
          reason: "",
          report_date: "",

          name1: "",
          name2: "",
          name3: ""

        },
        rules: {
          office_ref_num: [{
            required: true,
            message: this.$t("suspension_notice.enter_office_ref_num"),
            trigger: "blur"
          }, ],
          zensou_tele: [{
            pattern: /^(?:|\d{3}-\d{3}-\d{4}|\d{2}-\d{4}-\d{4}|\d{3}-\d{4}-\d{4})$/,
            message: this.$t("companyInfo.filltel"),
            trigger: "blur"
          }, ],
        },

        tableData: [],
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        dialogDetails: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false
      };
    },
    methods: {
      open1() {
        const h = this.$createElement;
        this.$notify({
          title: this.$t("suspension_notice.resume_date"),
          message: h(
            "warning", {
              style: "color: red"
            },
            this.$t("suspension_notice.hint_open1")
          )
        });
      },
      open2() {
        const h = this.$createElement;
        this.$notify({
          title: this.$t("suspension_notice.reason"),
          message: h(
            "i", {
              style: "color: teal"
            },
            this.$t("suspension_notice.hint_open2")
          )
        });
      },
      preview(index, row) {
        var uid = window.localStorage.getItem('LoginUserId');
        window.open("/pdf/適用事業所が廃止、休止等により適用事業所-" + "uid=" + uid + ".pdf");
      },

      reasonMesg() {
        const h = this.$createElement;
        this.$notify({
          title: this.$t("suspension_notice.not_applicable_over_70_years"),
          message: h("w", this.$t("suspension_notice.hint_reasonMesg"))
        });
      },
      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id
        });
        this.axios({
            method: "post",
            url: "/SuspensionNoticePDF",
            data: postData
          })
          .then(response => {
            this.handleCurrentChange();
            this.$message({
              type: "success",
              message: this.$t("general.print_completed")
            });
            setTimeout(() => {
              this.preview(index, row);
            }, 700);
            // console.log(response);
          })
          .catch(error => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed")
            });
            console.log(error);
          });
      },
      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleDetails(index, row) {
        this.dialogDetails = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleDelete(index, row) {
        // console.log(index, row);
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonClass: "btn-custom-confirm",
            confirmButtonText: "OK",
            cancelButtonText: this.$t("general.cancel"),
            type: "warning"
          })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id
            });
            this.axios({
                method: "post",
                url: "/deleteSuspensionNotice",
                data: postData
              })
              .then(response => {
                this.getPages();
                this.currentPage = 1;
                this.axios
                  .post("/pageSuspensionNotice")
                  .then(response => {
                    this.tableData = response.data;
                  })
                  .catch(error => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed")
                });
                // console.log(response);
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled")
            });
          });
      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonClass: "btn-custom-confirm",
            confirmButtonText: this.$t("general.confirm"),
            cancelButtonText: this.$t("general.cancel"),
            type: "warning"
          })
          .then(_ => {
            this.emptyUserData();
            done();
          })
          .catch(_ => {});
      },
      handleCurrentChange() {
        // console.log(`this.$t("general.current_page"): ${this.currentPage}`);
        let postData = this.qs.stringify({
          page: this.currentPage
        });
        this.axios({
            method: "post",
            url: "/pageSuspensionNotice",
            data: postData
          })
          .then(response => {
            this.tableData = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
        this.$refs[ruleForm].resetFields();
      },
      cancel() {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
      },
      emptyUserData() {
        this.ruleForm = {
          id: "",
          office_ref_num: "",
          zensou_date: "",
          zensou_causes: "",
          resume_date: "",
          zensou_postcode: "",
          zensou_address: "",
          zensou_name: "",
          zensou_tele: "",
          reason: "",
          report_date: "",

          name1: "",
          name2: "",
          name3: ""
        };
      },
      addUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              office_ref_num: this.ruleForm.office_ref_num,
              zensou_date: this.ruleForm.zensou_date,
              zensou_causes: this.ruleForm.zensou_causes,
              resume_date: this.ruleForm.resume_date,
              zensou_postcode: this.ruleForm.zensou_postcode,
              zensou_address: this.ruleForm.zensou_address,
              zensou_name: this.ruleForm.zensou_name,
              zensou_tele: this.ruleForm.zensou_tele,
              reason: this.ruleForm.reason,
              report_date: this.ruleForm.report_date
            });
            this.axios({
                method: "post",
                url: "/insertSuspensionNotice",
                data: postData
              })
              .then(response => {
                this.axios
                  .post("/pageSuspensionNotice")
                  .then(response => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.cancel();
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed")
                    });
                  })
                  .catch(error => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed")
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      updateUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              office_ref_num: this.ruleForm.office_ref_num,
              zensou_date: this.ruleForm.zensou_date,
              zensou_causes: this.ruleForm.zensou_causes,
              resume_date: this.ruleForm.resume_date,
              zensou_postcode: this.ruleForm.zensou_postcode,
              zensou_address: this.ruleForm.zensou_address,
              zensou_name: this.ruleForm.zensou_name,
              zensou_tele: this.ruleForm.zensou_tele,
              reason: this.ruleForm.reason,
              report_date: this.ruleForm.report_date
            });
            this.axios({
                method: "post",
                url: "/updateSuspensionNotice",
                data: postData
              })
              .then(response => {
                this.handleCurrentChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed")
                });
                // console.log(response);
              })
              .catch(error => {
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_failed")
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      getPages() {
        this.axios
          .post("/rowsSuspensionNotice")
          .then(response => {
            this.total = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      },
      getPages() {
        this.axios
          .post("/rowsSuspensionNotice")
          .then(response => {
            this.total = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      }
    },
    created() {
      this.axios
        .post("/pageSuspensionNotice")
        .then(response => {
          // console.log(response.data);
          this.show = true
          this.tableData = response.data;
        })
        .catch(error => {
          this.show = false;
          this.$message({
            type: 'error',
            message: '開発中です。'
          });
          console.log(error);
        });

      this.axios
        .post("/rowsSuspensionNotice")
        .then(response => {
          this.total = response.data;
        })
        .catch(error => {
          console.log(error);
        });

      this.axios
        .post("/ListComInfo")
        .then((response) => {
          // console.log(response.data);
          this.companyInfo = response.data;
          // console.log(this.companyInfo);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
</script>


<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }
</style>
<style scoped>
  .search_name {
    width: 200px;
  }

  .item1 {
    visibility: hidden;
  }

  .item2 {
    visibility: hidden;
  }

  .style1 {
    margin-right: 145px;
    padding: 0px;
    text-align: right;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/HealthIns/SuspensionNotice.vue